<div>
  <app-base-report *ngIf="salesReportData"
                   [filterFields]="filterField"
                   [hasDateRangeFilter]="true"
                   [hasCheckboxes]="false"
                   [reportName]="reportName"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="salesReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChange($event)"
                   [tableLoading]="loading"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="salesReportService"
                   [ExtpendableColumn]="'merchantRefNumber'"
                   (ExtpendableRowClicke)="RefunmForPaymentChange($event)"
                   [rowActions]="rowActions"
                   (rowActionClicked)="rowActionClicked($event)"
                   [identifierKey]="'paId'"></app-base-report>
</div>

<div class="popup" *ngIf="curuntTicket.length">
  <div class="ticket-container">
    <div class="table-container">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th *ngIf="ticket['description']" scope="col">Description</th>
            <th scope="col">Total</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ticket of curuntTicket">
            <th>{{ ticket['name'] }}</th>
            <td *ngIf="ticket['description']">{{ ticket['description'] }}</td>
            <td>{{ ticket['total'] }}</td>
            <td>{{ ticket['dateFormatted'] }}</td>
          </tr>
        </tbody>
      </table>
      <div class="controll">
        <button class="btn btn-success" (click)="closePopup()">Close</button>
      </div>
    </div>
  </div>
</div>
